<script lang="ts" setup>
defineProps<{
  fullWidth?: boolean
}>()
</script>

<template>
  <div
    :class="{
      'min-w-[80px]': !fullWidth,
      'w-max': fullWidth,
    }"
    class="absolute z-4 left-2/4 top-[90%] -translate-x-2/4 -translate-y-[90%] px-3 text-center rounded-full py-1 bg-background text-gray-500 text-xs"
  >
    <slot />
  </div>
</template>
